// extracted by mini-css-extract-plugin
export default {"window":"wDuRi5aJXHFNrGsif9C6sA==","pages":"xOaDpf-nOJR8xf--+EcF-w==","page":"BSumk8LkDvsF9SCNIFwOKg=="};